import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import HomePage from './HomePage';
import XPage from './XPage';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/x" element={<XPage />} />
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
